<template>

  <ControlloVociFattura />
 
</template>

<script>
import ControlloVociFattura from '../components/pratiche/ControlloVociFattura.vue'

export default {
  components: {
    ControlloVociFattura
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

